import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/user", { params });
  },
  get(id) {
    return http.get(`/api/v1/admin/user/${id}`);
  },
  save(payload) {
    return http.post("/api/v1/admin/user", payload);
  },
  update(id, payload) {
    return http.put(`/api/v1/admin/user/${id}`, payload);
  },
  toggleStatus(id, isActive) {
    return http.put(`/api/v1/admin/user/${id}/active`, null, {
      params: {
        isActive,
      },
    });
  },
  delete(id) {
    return http.delete(`/api/v1/admin/user/${id}`);
  },
  getUserInfo() {
    return http.get("/api/v1/admin/auth/me");
  }
};